import {createContext } from 'react';
import { IUserContext } from './users';

const UserAtGroupContext = createContext<IUserContext>({} as IUserContext);

export default UserAtGroupContext;